import { ConstantsCodesObjectType, ConstantsCodeType } from 'src/types/constantsCodes';
import { checkPermission } from 'src/utils/checkPermission';
import { ClaimStatusesTo } from 'skladon-types';
import { sortByClaimStatusOrder } from 'src/resources/constantsCodes/functions';

export const getAllowedStatuses = (
    claimStatusCodes: ConstantsCodeType[],
    claimStatusCodesObject: ConstantsCodesObjectType,
    claimData: { STATUS: string }
): ConstantsCodeType[] => {
    if (checkPermission('CLAIM.EDITALL')) {
        return sortByClaimStatusOrder(claimStatusCodes);
    }

    if (!claimData) {
        return [];
    }

    if (!checkPermission(`CLAIM.STATUS.EDIT.${claimData.STATUS.toUpperCase()}`)) {
        return [];
    }

    return sortByClaimStatusOrder(
        (ClaimStatusesTo[claimData.STATUS] || [])
            .filter((statusKey) => {
                return checkPermission(`CLAIM.STATUS.LIST.${statusKey.toUpperCase()}`);
            })
            .map((statusKey) => {
                return claimStatusCodesObject[statusKey];
            })
    );
};
